module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ella-best-802d9319655e64535c3ad6d372538572.jpg";